import React, { useState, useEffect, useRef } from "react"
import Tooltip from "./Tooltip"

const HintTile = React.memo(function HintTile({ label, value, revealed, className, tooltipLines, animateHints }) {
  const prevRevealed = useRef(revealed)
  const [flash, setFlash] = useState(false)

  useEffect(() => {
    if (!prevRevealed.current && revealed && animateHints) {
      setFlash(true)
      const t = setTimeout(() => setFlash(false), 600)
      prevRevealed.current = true
      return () => clearTimeout(t)
    } else {
      prevRevealed.current = revealed
    }
  }, [revealed, animateHints])

  return (
    <Tooltip lines={tooltipLines}>
      <div className={`gs-hint-tile ${revealed ? "revealed" : ""} ${flash ? "flash" : ""}`}>
        <span className="gs-hint-label">{label}</span>
        <span className={`gs-hint-val ${revealed ? (className || "") : "unknown"}`}>
          {value || "?"}
        </span>
      </div>
    </Tooltip>
  )
})

export default HintTile
